import {ChangeDetectionStrategy, Component} from '@angular/core';
import {environment} from '@environments/environment';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoaderComponent {
  client = environment.name;

  readonly riveClients = ['ekstraklasa', 'lff'];

  readonly isRiveClient = this.riveClients.includes(this.client);
}
